<template>
  <section class="chat-application ">
    <section class="container-chat chat-widget ">
      <section class="chat-app-window ">

        <b-card class="chatbot rounded-0  " body-class="content-mensajes user-chats   " header-bg-variant="primary"
          header-text-variant="white">

          <section ref="refChatLogPS" class="h-100 scroll-area">

            <chat-log :actions="actions" :esperando-respuesta="esperandoRespuesta" :ref-scroll="refChatLogPS" :is-component="isComponent" />

            <section class="only-mensajes-empty d-flex justify-content-center align-items-center h-100 "
              v-if="!mensajes.length">

              <article
                class="border-1 border-secondary p-1 rounded-start rounded-end py-1 d-flex flex-column align-items-center">

                <em class="text-center text-muted" v-if="!isComponent">
                  Puedes escribir un mensaje cuando gustes e interactuar con Nuestro
                  Chat. ¡Está disponible aquí para tí!
                </em>

                <em class="text-center text-muted" v-else>
                  Escribe un mensaje para iniciar el chat con Soporte.
                </em>

                <strong class="text-danger" v-if="!isComponent && !$can('read','Chat')">
                  <font-awesome-icon icon="fas fa-lock" /> No tienes permiso para interactuar con el Chat.
                </strong>

              </article>

            </section>

          </section>
        </b-card>

      </section>
    </section>

  </section>

</template>

<script setup>


import useUsuarioStore from '@/store/usuario';

import ChatLog from 'components/ChatLog.vue';


import useRootStore from '@/store/root';
const usuario_store = useUsuarioStore();
const root_store = useRootStore();

const { usuario } = storeToRefs(usuario_store);
const {loading} = storeToRefs(root_store);

const props = defineProps({
  actions: {
    type: Object,
    default:() => ({})
  },
  isComponent: {
    type: Boolean,
    default: false
  },

});

const {actions} = toRefs(props)

  const {
    mensajes,
    aperturado,
    refChatLogPS,
    esperandoRespuesta,
    // methods
    enviar,
    cerrar,
    abrirChat,
    aperturarChat,
    scrollToBottomInChatLog,
    cerrarChat
  } = actions.value;






</script>


<style lang="scss">
@use '@variables/variables' as *;
@import "@/assets/scss/base/pages/app-chat.scss";
@import "@/assets/scss/base/pages/app-chat-list.scss";

.chat-application {
  width:100%;
  .container-chat {
    height: 100%;
    position: relative;

    .chatbot {
      border-radius: 10px;
      transition: all .5s ease-in-out;
      height: 100%;
      display: flex;
      flex-direction: column;
      width: 100%;

      .card-header {
        flex: 0 1 auto !important;
      }

      .card-footer {
        flex: 0 1 70px !important;
      }

      &.oculto {
        min-width: 0px;
        margin-bottom: -100%;
        width: 0px !important;
        height: 0px;
      }
      
      .scroll-area {
        height: 100%;
        overflow-y: auto;
        padding: 0 0px;
        margin: 0 0rem;
        width: 100%;
      }

    }
  }
}


.chat-left {
  padding-left: .5rem;
}

.user-chats {
  padding: 0px 10px !important;
  margin: 0px;
}
</style>
